import { AutoMap } from '@automapper/classes';

export class PompeEntity {
    Id?: number;
    @AutoMap()
    Reference!: string;
    /** DEPRECATED */
    Bluetooth!: boolean;
    @AutoMap()
    ElectriciteAccessible!: boolean;
    @AutoMap()
    DebitInitial!: number;
    @AutoMap()
    DebitFinal!: number;
    @AutoMap()
    CompteurVolInitial!: number;
    @AutoMap()
    CompteurVolFinal!: number;
    @AutoMap()
    CompteurHoraireInitial!: number;
    @AutoMap()
    CompteurHoraireFinal!: number;
}
